import React, { useState } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators, compose } from 'redux';

import * as action from './actions';
import { makeSelectRuleGenData } from './selector';
import './_ruleGen.scss';
import SecondaryButton from '../UtilComponents/SecondaryButton';
import { MetaBlock } from './UtilComponents';
import LocaleHoc from '../../LocaleHoc';
import * as constants from './constants';
import AiraContainer from '../UtilComponents/AiraContainer';
import CapSpin from '../../CapSpin';
import CapRow from '../../CapRow';
import { getRuleApi, updateDislikeResultApi, updateLikeResultApi } from './api';
import ErrorBar from '../UtilComponents/ErrorBar';
import InputBox from '../UtilComponents/InputBox';
import { AiraCorner } from '../UtilComponents/Icons';

const RuleGenerationBot = ({
  popupWidth,
  textAiraTitle,
  textAiraTooltip,
  textRulePlaceholder,
  textCopy,
  textCopied,
  textRuleLoading,
  textThank,
  textError,
  textAddCommentPlaceholder,
  textWarn,
  askAiraData,
  actions,
  activity,
  request,
  getAPICallObject,
  iconPlacement,
}) => {
  const [query, setQuery] = useState('');
  const [copyText, setCopyText] = useState(textCopy);

  const { REQUEST } = constants;
  const { getRuleStatus, getRuleError, ruleObj } = askAiraData;

  const onSubmit = async () => {
    actions.getRule({
      getRuleApi: getRuleApi(request, getAPICallObject),
      query: { activity, query },
    });
    setCopyText(textCopy);
  };

  const onHide = () => {
    setQuery('');
    setCopyText(textCopy);
    actions.resetRule();
  }

  const handleCopyBtnClick = () => {
    navigator?.clipboard?.writeText(ruleObj?.rule);
    setCopyText(textCopied);
  };

  return (
    <AiraContainer
      titlePadding="0.5rem"
      popupWidth={popupWidth}
      Icon={AiraCorner}
      iconPlacement={iconPlacement}
      popupPlacement={{ type: 'anchor-br' }}
      title={textAiraTitle}
      titleDescription={textAiraTooltip}
      onHide={onHide}
    >
      <div style={{ padding: '1rem' }}>
        <InputBox
          value={query}
          setValue={setQuery}
          showSend={getRuleStatus === REQUEST}
          loading={getRuleStatus === REQUEST}
          placeholder={textRulePlaceholder}
          onSubmit={onSubmit}
        />

        {getRuleStatus === REQUEST && (
          <CapRow
            type="flex"
            align="middle"
            style={{ gap: '1.3rem', padding: '1rem 1rem 0 1rem' }}
          >
            <div style = {{position: 'relative'}}>
              <CapSpin spinning={getRuleStatus === REQUEST} />
            </div>
            <span style={{ color: '#808080', fontSize: '0.9rem' }}>
              {textRuleLoading}
            </span>
          </CapRow>
        )}
        {getRuleError && <ErrorBar textError={textError} />}
        {ruleObj?.rule && (
          <>
            <CapRow
              type="flex"
              justify="space-between"
              style={{ padding: '1rem 0', flexWrap: 'nowrap' }}
            >
              <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                {ruleObj.rule}
              </div>
              <SecondaryButton
                iconName="copy"
                data-testid="copy-button"
                text={copyText}
                onClick={handleCopyBtnClick}
              />
            </CapRow>
            <MetaBlock
              textThank={textThank}
              textAddCommentPlaceholder={textAddCommentPlaceholder}
              textWarn={textWarn}
              requestId={ruleObj?.requestId}
              actions={actions}
              updateLikeResultApi={updateLikeResultApi(
                request,
                getAPICallObject,
              )}
              updateDislikeResultApi={updateDislikeResultApi(
                request,
                getAPICallObject,
              )}
            />
          </>
        )}
      </div>
    </AiraContainer>
  );
};

RuleGenerationBot.defaultProps = {
  popupWidth: '42rem',
  askAiraData: {},
};

const mapStateToProps = createStructuredSelector({
  askAiraData: makeSelectRuleGenData(),
});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(action, dispatch),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(
  LocaleHoc(RuleGenerationBot, {
    key: 'CapAskAira.RuleGenerationBot',
  }),
);
